import React from 'react';
import PropTypes from 'prop-types';

class Step extends React.Component {
    constructor(props) {
        super(props);

        this.renderSkipLink = this.renderSkipLink.bind(this);
        this.renderNextLink = this.renderNextLink.bind(this);
        this.renderStepIndicators = this.renderStepIndicators.bind(this);
    }

    renderSkipLink() {
        const { showSkip, onSkip, skipText } = this.props;

        if (!showSkip) {
            return null;
        }

        return (
            <button className="step__skip btn is-big" onClick={onSkip}>
                {skipText}
            </button>
        );
    }

    renderNextLink() {
        const { nextText, onNext } = this.props;

        return (
            <button className="step__next btn is-big" onClick={onNext}>
                {nextText}
            </button>
        );
    }

    renderStepIndicators() {
        const indicators = [];
        const { stepNo, totalSteps, showStepIndicators } = this.props;

        if (!showStepIndicators) {
            return null;
        }

        for (let i = 1; i <= totalSteps; i++) {
            const classes = ['step__indicator', `step__indicator--${i}`];
            if (i === stepNo) {
                classes.push('step__indicator--active');
            }
            indicators.push(<div className={classes.join(' ')} key={`step-${i}`} />);
        }

        return <div className="step__indicators">{indicators}</div>;
    }

    render() {
        const { headline, description, image } = this.props;
        return (
            <div className="step">
                <div className="step__inner">
                    <div className="step__image">
                        <img src={image} alt="" />
                    </div>
                    <div className="step__body">
                        {this.renderStepIndicators()}
                        <h1 className="step__headline">{headline}</h1>
                        <p className="step__description">{description}</p>
                    </div>
                    <footer className="step__footer">
                        {this.renderSkipLink()}
                        {this.renderNextLink()}
                    </footer>
                </div>
            </div>
        );
    }
}

Step.propTypes = {
    stepNo: PropTypes.number,
    totalSteps: PropTypes.number,
    showStepIndicators: PropTypes.bool,
    headline: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    image: PropTypes.string.isRequired,
    showSkip: PropTypes.bool,
    skipText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    onSkip: PropTypes.func,
    nextText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    onNext: PropTypes.func.isRequired,
};

Step.defaultProps = {
    showSkip: false,
    showStepIndicators: false,
    stepNo: 1,
    totalSteps: 1,
    description: '',
};

export default Step;
